/* eslint-disable no-param-reassign,react/no-danger */
import React, { useId } from 'react';

const scriptFrag = `
var indexedDestroyers = {};
var mountedMenuIds = {};
var allTabbableEls = 'a[href],area[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),iframe,[tabindex],[contentEditable=true]';
var mountMenu = function (rootScopeId) {
    if (mountedMenuIds[rootScopeId]) {
        return;
    }
    mountedMenuIds[rootScopeId] = true;
    indexedDestroyers[rootScopeId] = [];
    var indicator = document.querySelector('[data-menu="indicator"]');
    var viewport = document.querySelector('[data-menu="viewport"]');
    var prevHeight = 0;
    var statefulIds = {};
    var currentMenuInstanceTime = 0;
    var bouncers = {};
    var indicatorBouncer;
    var activeHitboxes = [];
    var hideMenu = function () { return function () {
        var items = Array.from(document.querySelectorAll("[data-menu-root-scope-id=\\"".concat(rootScopeId, "\\"] [data-menu=\\"item\\"]")));
        items.forEach(function (item) {
            if (item) {
                var trigger = item.querySelector('[data-menu="trigger"]');
                var content_1 = item.querySelector('[data-menu="content"]');
                var viewportRenderer_1 = item.querySelector('[data-menu="viewport-render"]');
                var menuId_1 = item.dataset.menuScope;
                if (trigger && content_1 && viewport && viewportRenderer_1 && menuId_1) {
                    if (statefulIds[menuId_1] === 'open') {
                        if (document.activeElement === item) {
                            item.blur();
                        }
                        statefulIds[menuId_1] = 'closing';
                        content_1.dataset.state = 'hidden';
                        trigger.dataset.state = 'closed';
                        viewportRenderer_1.dataset.state = 'closed';
                        trigger.blur();
                        if (indicator) {
                            indicator.dataset.state = 'hidden';
                        }
                        content_1.querySelectorAll(allTabbableEls).forEach(function (item) {
                            if ('tabIndex' in item) {
                                // eslint-disable-next-line no-param-reassign
                                item.tabIndex = -1;
                            }
                        });
                        var delayTime = Number(content_1.dataset.menuTime || 0) || 0;
                        bouncers[menuId_1] = setTimeout(function () {
                            content_1.ariaHidden = 'true';
                            viewportRenderer_1.style.removeProperty('--menu-viewport-width');
                            viewportRenderer_1.style.removeProperty('--menu-viewport-height');
                            if (statefulIds[menuId_1] !== 'opening' && statefulIds[menuId_1] !== 'open') {
                                statefulIds[menuId_1] = undefined;
                            }
                        }, delayTime);
                        indicatorBouncer = setTimeout(function () {
                            if (indicator) {
                                indicator.ariaHidden = 'false';
                            }
                        }, delayTime);
                    }
                }
            }
        });
    }; };
    var createScrollListenerForMenu = function () {
        hideMenu()();
    };
    window.addEventListener('scroll', createScrollListenerForMenu);
    indexedDestroyers[rootScopeId].push(function () { return window.removeEventListener('scroll', createScrollListenerForMenu); });
    var hitboxTimeout;
    var showMenu = function (menuId, isPassive) { return function () {
        if (statefulIds[menuId] === 'opening') {
            return;
        }
        if (statefulIds[menuId] === 'closing' && isPassive) {
            return;
        }
        // This is to ensure that we hide current if the event isn't triggered
        statefulIds[menuId] = 'opening';
        hideMenu()();
        currentMenuInstanceTime = Date.now();
        var item = document.querySelector("[data-menu-root-scope-id=\\"".concat(rootScopeId, "\\"] [data-menu=\\"item\\"][data-menu-scope=\\"").concat(menuId, "\\"]"));
        if (item) {
            var trigger = item.querySelector('[data-menu="trigger"]');
            var content = item.querySelector('[data-menu="content"]');
            var viewportRenderer_2 = item.querySelector('[data-menu="viewport-render"]');
            if (trigger && content && viewport && viewportRenderer_2) {
                clearTimeout(bouncers[menuId]);
                bouncers[menuId] = undefined;
                clearTimeout(indicatorBouncer);
                indicatorBouncer = undefined;
                var contentBox_1 = content.getBoundingClientRect();
                content.querySelectorAll(allTabbableEls).forEach(function (item) {
                    if ('tabIndex' in item) {
                        // eslint-disable-next-line no-param-reassign
                        item.tabIndex = 0;
                    }
                });
                viewportRenderer_2.style.setProperty('transition', 'none');
                viewportRenderer_2.style.setProperty('--menu-viewport-width', "".concat(Math.round(contentBox_1.width), "px"));
                viewportRenderer_2.style.setProperty('--menu-viewport-height', "".concat(Math.round(prevHeight), "px"));
                content.ariaHidden = 'false';
                content.dataset.state = 'visible';
                trigger.dataset.state = 'open';
                viewportRenderer_2.dataset.state = 'open';
                var _a = trigger.getBoundingClientRect(), x = _a.x, width = _a.width;
                var screenW = document.body.offsetWidth;
                viewportRenderer_2.style.setProperty('--menu-viewport-self-x', "".concat(Math.round(x + (width / 2) - (contentBox_1.width / 2)), "px"));
                viewportRenderer_2.style.setProperty('--menu-viewport-center-x', "".concat(Math.round((screenW / 2) - (contentBox_1.width / 2)), "px"));
                if (indicator) {
                    var parentElementNum = 0;
                    if (indicator.parentElement) {
                        parentElementNum = indicator.parentElement.getBoundingClientRect().left;
                    }
                    indicator.ariaHidden = 'false';
                    indicator.dataset.state = 'visible';
                    indicator.style.transform = "translateX(".concat(Math.round(x - parentElementNum), "px)");
                    indicator.style.width = "".concat(Math.round(width), "px");
                }
                setTimeout(function () {
                    viewportRenderer_2.style.setProperty('--menu-viewport-height', "".concat(Math.round(contentBox_1.height + 2), "px"));
                    viewportRenderer_2.style.removeProperty('transition');
                    prevHeight = contentBox_1.height;
                    if (statefulIds[menuId] !== 'closing' && statefulIds[menuId]) {
                        statefulIds[menuId] = 'open';
                    }
                }, 5);
            }
        }
    }; };
    var toggleMenu = function (menuId) { return function () {
        if (statefulIds[menuId] === 'open' && currentMenuInstanceTime < Date.now() - 100) {
            hideMenu()();
        }
        else if (statefulIds[menuId] === undefined) {
            showMenu(menuId)();
        }
    }; };
    var addHitbox = function (id) { return function () {
        clearTimeout(hitboxTimeout);
        activeHitboxes = [id];
    }; };
    var removeHitbox = function (id) { return function () {
        activeHitboxes = activeHitboxes.filter(function (x) { return x !== id; });
        hitboxTimeout = setTimeout(function () {
            if (activeHitboxes.length === 0) {
                hideMenu()();
            }
        }, 50);
    }; };
    var root = document.querySelector("[data-menu-root-scope-id=\\"".concat(rootScopeId, "\\"]"));
    var removeAllHitboxesOnRootExit = function () {
        clearTimeout(hitboxTimeout);
        activeHitboxes = [];
        hideMenu()();
    };
    if (root) {
        root.addEventListener('mouseleave', removeAllHitboxesOnRootExit);
        indexedDestroyers[rootScopeId].push(function () { return root.removeEventListener('mouseleave', removeAllHitboxesOnRootExit); });
    }
    var firstElementTrigger = document.querySelector("[data-menu-root-scope-id=\\"".concat(rootScopeId, "\\"] [data-menu=\\"trigger\\"]"));
    if (indicator && firstElementTrigger) {
        var _a = firstElementTrigger.getBoundingClientRect(), x = _a.x, width = _a.width;
        var parentElementNum = 0;
        if (indicator.parentElement) {
            parentElementNum = indicator.parentElement.getBoundingClientRect().left;
        }
        indicator.style.transform = "translateX(".concat(x - parentElementNum, "px)");
        indicator.style.width = "".concat(width, "px");
    }
    document.querySelectorAll("[data-menu-root-scope-id=\\"".concat(rootScopeId, "\\"] [data-menu=\\"item\\"]")).forEach(function (item) {
        var trigger = item.querySelector('[data-menu="trigger"]');
        var content = item.querySelector('[data-menu="content"]');
        var viewportRenderer = item.querySelector('[data-menu="viewport-render"]');
        var viewportClassNames = viewport === null || viewport === void 0 ? void 0 : viewport.classList;
        if (viewportRenderer && viewportClassNames) {
            Array.from(viewportClassNames).forEach(function (className) {
                viewportRenderer.classList.add(className);
            });
        }
        if (trigger && content && viewport && viewportRenderer && item.dataset.menuScope) {
            // disable all focusable items
            content.querySelectorAll(allTabbableEls).forEach(function (item) {
                if ('tabIndex' in item) {
                    // eslint-disable-next-line no-param-reassign
                    item.tabIndex = -1;
                }
            });
            // const itemMouseOverFunc = showMenu(item.dataset.menuScope);
            // item.addEventListener('mouseover', itemMouseOverFunc);
            // indexedDestroyers[rootScopeId].push(() => item.removeEventListener('mouseover', itemMouseOverFunc));
            // const itemFocusInFunc = showMenu(item.dataset.menuScope);
            // item.addEventListener('focusin', itemFocusInFunc);
            // indexedDestroyers[rootScopeId].push(() => item.removeEventListener('focusin', itemFocusInFunc));
            var triggerEnterFunc_1 = showMenu(item.dataset.menuScope);
            trigger.addEventListener('mouseover', triggerEnterFunc_1);
            indexedDestroyers[rootScopeId].push(function () { return trigger.removeEventListener('mouseover', triggerEnterFunc_1); });
            var triggerFunc_1 = addHitbox("trigger_".concat(item.dataset.menuScope));
            trigger.addEventListener('mouseenter', triggerFunc_1);
            indexedDestroyers[rootScopeId].push(function () { return trigger.removeEventListener('mouseenter', triggerFunc_1); });
            var triggerFuncClick_1 = toggleMenu(item.dataset.menuScope);
            trigger.addEventListener('click', triggerFuncClick_1);
            indexedDestroyers[rootScopeId].push(function () { return trigger.removeEventListener('click', triggerFuncClick_1); });
            var triggerMouseLeaveFunc_1 = removeHitbox("trigger_".concat(item.dataset.menuScope));
            trigger.addEventListener('mouseleave', triggerMouseLeaveFunc_1);
            indexedDestroyers[rootScopeId].push(function () { return trigger.removeEventListener('mouseleave', triggerMouseLeaveFunc_1); });
            var contentMouseEnterFunc_1 = addHitbox("content_".concat(item.dataset.menuScope));
            content.addEventListener('mouseenter', contentMouseEnterFunc_1);
            indexedDestroyers[rootScopeId].push(function () { return content.removeEventListener('mouseenter', contentMouseEnterFunc_1); });
            var contentMouseLeaveFunc_1 = removeHitbox("content_".concat(item.dataset.menuScope));
            content.addEventListener('mouseleave', contentMouseLeaveFunc_1);
            indexedDestroyers[rootScopeId].push(function () { return content.removeEventListener('mouseleave', contentMouseLeaveFunc_1); });
            var viewportRendererMouseEnterFunc_1 = addHitbox("viewport_".concat(item.dataset.menuScope));
            viewportRenderer.addEventListener('mouseenter', viewportRendererMouseEnterFunc_1);
            indexedDestroyers[rootScopeId].push(function () { return viewportRenderer.removeEventListener('mouseenter', viewportRendererMouseEnterFunc_1); });
            var viewportRendererMouseLeaveFunc_1 = removeHitbox("viewport_".concat(item.dataset.menuScope));
            viewportRenderer.addEventListener('mouseleave', viewportRendererMouseLeaveFunc_1);
            indexedDestroyers[rootScopeId].push(function () { return viewportRenderer.removeEventListener('mouseleave', viewportRendererMouseLeaveFunc_1); });
        }
    });
};
var unmountMenu = function (rootScopeId) {
    if (indexedDestroyers[rootScopeId]) {
        indexedDestroyers[rootScopeId].forEach(function (destroyer) { return destroyer(); });
        indexedDestroyers[rootScopeId] = [];
    }
    if (mountedMenuIds[rootScopeId]) {
        mountedMenuIds[rootScopeId] = false;
    }
};
var mountAllMenus = function () {
    Array.from(document.querySelectorAll('[data-menu-root-scope-id]')).forEach(function (item) {
        var scope = item.dataset.menuRootScopeId;
        if (scope) {
            mountMenu(scope);
        }
    });
};
var onReady = function (fn) {
    // see if DOM is already available
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        // call on next available tick
        setTimeout(fn, 1);
    }
    else {
        document.addEventListener('DOMContentLoaded', fn);
    }
};
onReady(function () {
    mountAllMenus();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.mountMenu = mountMenu;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.unmountMenu = unmountMenu;
});
`;

const wrappedScriptFrag = `<script>${scriptFrag}</script>`;

const Script = (): JSX.Element => {
    const elRef = React.useRef<HTMLSpanElement|null>(null);

    React.useEffect(() => {
        if (elRef.current) {
            if ('innerHTML' in elRef.current) {
                const range = document.createRange();
                range.selectNode(elRef.current);
                const documentFragment = range.createContextualFragment(wrappedScriptFrag);
                elRef.current.innerHTML = '';
                elRef.current.append(documentFragment);
            }
        }
    }, []);

    return (
        <span ref={elRef} dangerouslySetInnerHTML={{ __html: wrappedScriptFrag }} />
    );
};

const Root = ({ children, className }: React.PropsWithChildren<{ className?: string }>): JSX.Element => {
    const rootScopeId = React.useId();

    React.useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window.mountMenu) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.mountMenu(rootScopeId);
        }
        return () => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (window.unmountMenu) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                window.unmountMenu(rootScopeId);
            }
        };
    }, [rootScopeId]);

    return (
        <div className={className} data-menu-root-scope-id={rootScopeId}>
            {children}
        </div>
    );
};

const List = ({ children, className }: React.PropsWithChildren<{ className?: string }>): JSX.Element => (
    <ul className={className}>
        {children}
    </ul>
);

const ItemContext = React.createContext<{
    id: string
}>({ id: '' });

const Item = ({ children, className }: React.PropsWithChildren<{ className?: string }>): JSX.Element => {
    const id = useId();
    const value = React.useMemo(() => ({ id }), [id]);
    return (
        <ItemContext.Provider value={value}>
            <li data-menu="item" data-menu-scope={id} className={className}>
                {children}
            </li>
        </ItemContext.Provider>
    );
};

const Trigger = ({ children, className }: React.PropsWithChildren<{ className?: string }>): JSX.Element => {
    const { id } = React.useContext(ItemContext);
    return (
        <button type="button" data-menu="trigger" data-state="closed" data-menu-scope={id} className={className}>
            {children}
        </button>
    );
};

const Content = ({ children, className, mode, animationTimeMs = 0 }: React.PropsWithChildren<{
    mode: 'center' | 'self',
    animationTimeMs?: number
    className?: string
}>): JSX.Element => {
    if (!mode) {
        throw new Error('A mode must be prescribed for Content.');
    }
    const { id } = React.useContext(ItemContext);
    return (
        <div css={{
            position: 'absolute',
            width: '100%',
            height: 'auto',
            left: '0',
            display: 'flex',
            alignItems: 'center',
        }}
        >
            <div data-menu-scope={id} data-menu="viewport-render" data-menu-mode={mode} tabIndex={-1}>
                <div
                    className={className}
                    aria-hidden
                    data-menu-scope={id}
                    data-menu-time={animationTimeMs}
                    css={{
                        '&[aria-hidden="true"]': {
                            clip: 'rect(0,0,0,0)',
                        },
                    }}
                    data-menu="content"
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

const Indicator = ({ children, className }: React.PropsWithChildren<{ className?: string }>): JSX.Element => (
    <div
        css={{
            position: 'absolute',
        }}
        className={className}
        data-menu="indicator"
        aria-hidden="true"
        data-state="unset"
    >
        {children}
    </div>
);

const Viewport = ({ className }: { className?: string }): JSX.Element => (
    <div
        data-menu="viewport"
        aria-hidden="true"
        css={{
            '--menu-viewport-height': '0px',
            '--menu-viewport-width': '0px',
        }}
        className={className}
    />
);

export {
    Root,
    List,
    Item,
    Trigger,
    Content,
    Indicator,
    Viewport,
    Script,
};
